<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>
    <v-card-text>
      <p class="message mb-0" v-if="message">{{ message }}</p>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text :disabled="loading" @click="$emit('close')">{{
        cancelText
      }}</v-btn>
      <v-btn :color="acceptColor" @click="confirm" :loading="loading">{{
        acceptText
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class ConfirmModal extends Vue {
    @Prop() title: string;
    @Prop({ default: 'Aceptar' }) acceptText: string;
    @Prop({ default: 'Cancelar' }) cancelText: string;
    @Prop({ default: 'primary' }) acceptColor: string;
    @Prop() subtitle: string;
    @Prop() message: string;
    @Prop() hint: string;
    @Prop() rules: any[];
    input: string = '';
    loading = false;

    async created() {}

    async confirm() {
      this.loading = true;

      await (<Function>this.$parent.$listeners.confirm)(this.input);

      this.loading = false;
    }
  }
</script>

<style scoped>
  .message {
    white-space: pre-line;
  }
</style>
